import React from 'react';
import { Col, Row } from 'antd';
import {
  RateCardAttributesType,
  SelectedOrganizationUnitType,
} from './_rates-long-term-context';
import { Card, Text } from '@common/components';

export function RatesLongTermStepSummaryAffectedItems({
  selectedOrganizationUnits,
  rateCardAttributes,
}: {
  selectedOrganizationUnits: SelectedOrganizationUnitType[];
  rateCardAttributes: RateCardAttributesType;
}) {
  const locations = locationCount(selectedOrganizationUnits);
  const units = clinicalCount(selectedOrganizationUnits);

  const {
    pendingStaffingRequestsCount,
    openStaffingRequestsCount,
    pendingOffersCount,
    extensionOffersCount,
  } = rateCardAttributes;

  return (
    <Card>
      <Row gutter={[0, 8]}>
        <AffectedItem label="Locations" value={locations} />
        <AffectedItem label="Units" value={units} />
        <AffectedItem
          label="Pending Staffing Requests"
          value={pendingStaffingRequestsCount}
        />
        <AffectedItem
          label="Open Staffing Requests"
          value={openStaffingRequestsCount}
        />
        <AffectedItem label="Pending Offers" value={pendingOffersCount} />
        <AffectedItem label="Extension Offers" value={extensionOffersCount} />
      </Row>
    </Card>
  );
}

function AffectedItem({ value = 0, label }: { value?: number; label: string }) {
  return (
    <>
      <Col span={2}>
        <Text bold>{value}</Text>
      </Col>
      <Col span={22}>
        <Text secondary>{label}</Text>
      </Col>
    </>
  );
}

function locationCount(
  selectedOrgUnits: SelectedOrganizationUnitType[]
): number {
  return new Set(selectedOrgUnits?.map((unit) => unit.businessId)).size;
}

function clinicalCount(
  selectedOrgUnits: SelectedOrganizationUnitType[]
): number {
  return new Set(selectedOrgUnits?.map((unit) => unit.clinicalId)).size;
}
